"use client";

import React from "react";
import styles from "./Marquee.module.scss";

interface MarqueeProps {
	speed?: number;
	direction?: "left" | "right";
	pauseOnHover?: boolean;
	className?: string;
}

const Marquee: React.FC<MarqueeProps> = ({ speed = 30, direction = "left", pauseOnHover = true, className = "" }) => {
	// Array of logo icons from public/logo-works
	const logos = ["/logo-works/1.svg", "/logo-works/2.svg", "/logo-works/3.svg", "/logo-works/4.svg", "/logo-works/5.svg", "/logo-works/6.svg", "/logo-works/7.svg", "/logo-works/8.svg", "/logo-works/9.svg"];

	return (
		<div className={`${styles.marquee} ${className}`}>
			<div
				className={`${styles.marquee__track} ${direction === "right" ? styles["marquee__track--reverse"] : ""} ${pauseOnHover ? styles["marquee__track--pauseOnHover"] : ""}`}
				style={
					{
						"--marquee-speed": `${speed}s`,
					} as React.CSSProperties
				}
			>
				{/* First set of logos */}
				<div className={styles.marquee__content}>
					{logos.map((logo, index) => (
						<div key={`logo-1-${index}`} className={styles.marquee__item}>
							<img src={logo} alt={`Partner logo ${index + 1}`} height={40} className={styles.marquee__logo} />
						</div>
					))}
				</div>

				{/* Duplicate set for seamless loop */}
				<div className={styles.marquee__content} aria-hidden="true">
					{logos.map((logo, index) => (
						<div key={`logo-2-${index}`} className={styles.marquee__item}>
							<img src={logo} alt={`Partner logo ${index + 1}`} height={40} className={styles.marquee__logo} />
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Marquee;
